import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { SpinnerFullWidth } from 'src/components/Spinner/SpinnerFullWidth';
import { ApplicationsStore } from 'src/stores/ApplicationsStore/ApplicationsStore';

export const IndexPage = observer(() => {
    const [isLoading, setIsLoading] = useState(true);
    const loadingList = async () => {
        await ApplicationsStore.loadList();
        setIsLoading(false);
    };
    useEffect(() => {
        loadingList();

        return () => {
            ApplicationsStore.listLoader.reset();
        };
    }, []);

    if (isLoading) {
        return <SpinnerFullWidth />;
    }

    if (ApplicationsStore.list.length > 0) {
        return <Redirect to="/applications" />;
    }

    return <Redirect to="/applications/create" />;
});
